/**
 * @file 文档页页面路由
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import { Button } from 'antd';
import A from '../../components/a/A';
import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import VerticalTabsList from '../../components/hub-components/vertical-tabs-list/VerticalTabsList';
import TextCardGroup from '../../components/text-card/TextCardGroup';
import TextCardGroup2 from '../paddle/components/text-card2/TextCards';
import usePaddleNlp from './PaddlenlpHook';
import IconCardGroup from '../paddle/components/icon-card/IconCardGroup';
import { IVerticalTabsListGroupItem } from '../../components/hub-components/vertical-tabs-list/types';
import PaddleNlpHotAppBar from './components/PaddleNlpHotApp/PaddleNlpHotAppBar';
import PaddleNlpToolset from './components/PaddleNlpToolset/PaddleNlpToolset';
import PaddleNlpInference from './components/PaddleNlpInference/PaddleNlpInference';
import PaddleNlpModelBlock from './components/PaddleNlpModelLibrary/PaddleNlpModelBlock';

const PaddleNlpPage = () => {
    const {
        pageData: {
            banner,
            openCommunication,
            corePriority,
            interaTutorial,
            example,
            hotApp,
            toolSet,
            reasoningTech,
            modelLibrary
        }
    } = usePaddleNlp();
    const mappedOpenCommunication = openCommunication?.list.map(item => ({
        title: item.title,
        text: item.desc,
        link: item.btnLink,
        tagText: item.bthWord
    }));

    const mappedCorePriority = corePriority?.list.map(item => ({
        title: item.title,
        iconUrl: item.imageUrl,
        text: item.desc
    }));

    const mappedInteraTutorial = interaTutorial?.list.map(item => ({
        title: item.title,
        content: item.desc,
        links: {
            label: item.btnWord,
            // todo: 最好从bthLink改成btnLink
            href: item.bthLink
        }
    }));

    const mappedExample = example?.list.map(item => ({
        title: item.title,
        list: [
            {
                title: item.title,
                desc: [
                    {
                        title: '',
                        text: item.desc
                    }
                ],
                imgUrl: item.image,
                btns: [
                    {
                        label: item.btnWord,
                        // todo: 最好从bthLink改成btnLink
                        href: item.bthLink,
                        target: true
                    }
                ]
            }
        ]
    })) as IVerticalTabsListGroupItem[];

    return (
        <div className="page paddle-paddle-page">
            <Header />

            {banner && (
                <Banner title={banner.title} className="paddle-paddle-page-banner" subtitle={banner.desc} divider>
                    <div className="paddle-paddle-page-banner-btn-group">
                        {banner.btnList.map(item => (
                            <A key={item.btnWord} href={item.btnLink} target={'_blank'}>
                                <Button className="paddle-paddle-page-banner-btn" type="primary" size="large">
                                    {item.btnWord}
                                </Button>
                            </A>
                        ))}
                    </div>
                </Banner>
            )}

            <div className="paddle-paddle-page-container">
                {!!hotApp && (
                    <div className="paddle-paddle-page-context">
                        <PaddleNlpHotAppBar appList={hotApp} />
                    </div>
                )}
                {!!corePriority && (
                    <>
                        <div className="paddle-paddle-page-h2">{corePriority.title}</div>
                        <div className="paddle-paddle-page-context">
                            <IconCardGroup cardList={mappedCorePriority} />
                        </div>
                    </>
                )}

                {!!toolSet && (
                    <>
                        <div className="paddle-paddle-page-h2">{toolSet.title}</div>
                        <div className="paddle-paddle-page-context">
                            <PaddleNlpToolset toolSet={toolSet} />
                        </div>
                    </>
                )}

                {!!modelLibrary && (
                    <>
                        <div className="paddle-paddle-page-h2">{modelLibrary.title}</div>
                        <div className="paddle-paddle-page-context">
                            <PaddleNlpModelBlock model={modelLibrary.preModel} />
                            <PaddleNlpModelBlock model={modelLibrary.appScene} />
                        </div>
                    </>
                )}

                {!!example && (
                    <>
                        <div className="paddle-paddle-page-h2">{example.title}</div>
                        <div className="paddle-paddle-page-h3">{example.desc}</div>
                        <div className="paddle-paddle-page-context">
                            <VerticalTabsList group={mappedExample} />
                        </div>
                    </>
                )}
                {!!reasoningTech && (
                    <>
                        <div className="paddle-paddle-page-h2">{reasoningTech.title}</div>
                        {/* todo: 需要添加一个新的subtitle */}
                        <div className="paddle-paddle-page-h3">{reasoningTech.title}</div>
                        <div className="paddle-paddle-page-context">
                            <PaddleNlpInference inferenceList={reasoningTech} />
                        </div>
                    </>
                )}
                {!!interaTutorial && (
                    <>
                        <div className="paddle-paddle-page-h2">{interaTutorial.title}</div>
                        <div className="paddle-paddle-page-context">
                            <TextCardGroup2 title={interaTutorial.title} subtitle={''} list={mappedInteraTutorial} />
                        </div>
                    </>
                )}
                {!!openCommunication && (
                    <>
                        <div className="paddle-paddle-page-h2">{openCommunication.title}</div>
                        <div className="paddle-paddle-page-context">
                            <TextCardGroup option={mappedOpenCommunication} />
                        </div>
                    </>
                )}
            </div>

            <Footer />
        </div>
    );
};

export default PaddleNlpPage;
